document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations) => {
        const item = document.querySelector('#shopify-pc__banner__body-title');
        
        if (item) {
            console.log('Element found, converting to <p>');
            
            // Create a new <p> element
            const newElement = document.createElement('p');
            
            // Copy all attributes from the old element
            for (let attr of item.attributes) {
                newElement.setAttribute(attr.name, attr.value);
            }
            
            // Copy the inner content
            newElement.innerHTML = item.innerHTML;
            
            // Replace the old element with the new one
            item.parentNode.replaceChild(newElement, item);
            
            // Disconnect observer to stop watching
            observer.disconnect();
        }
    });
    
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Safety timeout to disconnect observer after 15 seconds
    setTimeout(() => {
        observer.disconnect();
        console.log('Observer timeout - stopped watching');
    }, 15000);
});

// Quick View: sync the gallery image and product links to the selected variant.
// The SM Recharge widget already updates price and the ATC variant; this fills
// the remaining gaps (variant image, Learn More / rating links). Scoped to
// single-option products — multi-option modals are left to the widget only.
(() => {
    document.addEventListener('click', (event) => {
        const li = event.target.closest('.js__popup-variant-select li');
        if (!li) return;

        const modal = li.closest('.js__quickview-modal');
        if (!modal) return;

        if (modal.querySelectorAll('.js__popup-variant-select').length > 1) return;

        const value = li.getAttribute('data-value');
        if (!value) return;

        const option = [...modal.querySelectorAll('[sm-rc-variant-selector] option')]
            .find((o) => o.getAttribute('data-title') === value);
        if (!option) return;

        syncQuickViewImage(modal, option.value);
        syncQuickViewLinks(modal, option.value);
    });

    function syncQuickViewImage(modal, variantId) {
        const swiper = modal.querySelector('.js__popup-collection-slider')?.swiper;
        if (!swiper) return;
        const slides = swiper.slides;
        for (let i = 0; i < slides.length; i++) {
            const ids = slides[i].getAttribute('data-variant-id');
            if (ids && ids.split(' ').indexOf(variantId) !== -1) {
                swiper.slideTo(i);
                return;
            }
        }
    }

    function syncQuickViewLinks(modal, variantId) {
        modal.querySelectorAll('.js__quickview-variant-link').forEach((link) => {
            const base = (link.getAttribute('href') || '').split('?')[0];
            if (base) link.setAttribute('href', `${base}?variant=${variantId}`);
        });
    }
})();